require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./centre-de-carrire-1-1-6.json") })
        }
      }, "path---centre-de-carrire-1-1-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---centre-de-carrire-1-1-6!./.cache/json/centre-de-carrire-1-1-6.json
// module id = 362
// module chunks = 231608221292675